import { BeiAn } from "@quark/design";
import styles from "./index.module.scss";
import { useKV } from "@quark/kits";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const { data: mpData } = useKV("hash-mp");

  return (
    <div className={styles.footer}>
      <div className={styles.infos}>
        <div className={styles.item}>
          <div className={styles.title}>联系我们</div>
          <div
            className={styles.link}
            onClick={() => navigate("/contact?type=business")}
          >
            商务合作
          </div>
          <div
            className={styles.link}
            onClick={() => navigate("/contact?type=school")}
          >
            校园合作
          </div>
          <div
            className={styles.link}
            onClick={() => navigate("/contact?type=private")}
          >
            私有部署
          </div>
        </div>
        <div className={styles.mp}>
          <img src={mpData?.value} alt="" />
          关注公众号
        </div>
      </div>
      <BeiAn className={styles.beian} />
    </div>
  );
};

export default Footer;
